'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconContainer = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  cursor: ', ';\n  pointer-events: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n\n  > svg {\n    vertical-align: ', ';\n    fill: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    &:hover {\n      fill: ', ';\n    }\n\n    ', '\n  }\n'], ['\n  cursor: ', ';\n  pointer-events: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n\n  > svg {\n    vertical-align: ', ';\n    fill: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    &:hover {\n      fill: ', ';\n    }\n\n    ', '\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getMarginValue = function getMarginValue(prop) {
  return function (props) {
    if (typeof props[prop] === 'undefined') {
      return null;
    }

    var value = typeof props[prop] === 'number' ? props[prop] + 'px' : props[prop];
    return 'margin-' + prop + ': ' + value + ';';
  };
};

var IconContainer = exports.IconContainer = _styledComponents2.default.span(_templateObject, function (props) {
  return props.cursor;
}, function (props) {
  return props.pointerEvents || 'auto';
}, getMarginValue('left'), getMarginValue('right'), getMarginValue('top'), getMarginValue('bottom'), function (props) {
  return props.alignment ? 'initial' : 'middle';
}, function (props) {
  return props.currentColor ? 'currentColor' : props.theme.color[props.variant];
}, function (props) {
  return props.theme.size[props.size];
}, function (props) {
  return props.theme.size[props.size];
}, function (props) {
  return props.theme.color[props.hoverVariant];
}, (0, _helpers.boolStyle)('shadow', '-webkit-filter: drop-shadow(0px 4px 3px rgba(0,0,0,0.1));filter: drop-shadow(0px 4px 3px rgba(0,0,0,0.1))'));
IconContainer.displayName = 'IconContainer';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/styles.js
// module id = 3011
// module chunks = 4